import { environment } from '#environments';
import { Dtos } from '#models';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TranslationRequestService {
  private http = inject(HttpClient);

  getTranslationRequestsByPssrId(pssrId: number): Observable<Dtos.TranslationRequest[]> {
    return this.http.get<Dtos.TranslationRequest[]>(`${environment.apiUrl}/pssr/${pssrId}/translationrequest`);
  }

  requestTranslation(payload: Dtos.TranslationRequest): Observable<Dtos.TranslationRequest> {
    return this.http.post<Dtos.TranslationRequest>(`${environment.apiUrl}/translationrequest`, payload);
  }

  getTranslationRequest(requestId: number): Observable<Dtos.TranslationRequest> {
    return this.http.get<Dtos.TranslationRequest>(`${environment.apiUrl}/translationrequest/${requestId}`);
  }

  switchTranslator(requestId: number, newTranslatorEmail: string) {
    return this.http.put<Dtos.TranslationRequest>(`${environment.apiUrl}/translationrequest/${requestId}`, {
      TranslatorEmail: newTranslatorEmail,
    });
  }

  completeTranslation(requestId: number): Observable<Dtos.TranslationRequest> {
    return this.http.put<Dtos.TranslationRequest>(`${environment.apiUrl}/translationrequest/${requestId}/completion`, {
      IsCompleted: true,
    });
  }
}
